export default __webpack_public_path__ + "static/media/reply_on.b5efc372.svg";